import { render } from "./OlapCustomViewSaveDialog.vue?vue&type=template&id=46c3e7a6&ts=true"
import script from "./OlapCustomViewSaveDialog.vue?vue&type=script&lang=ts"
export * from "./OlapCustomViewSaveDialog.vue?vue&type=script&lang=ts"

import "./OlapCustomViewSaveDialog.vue?vue&type=style&index=0&id=46c3e7a6&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__